export enum JobStatusEnum {
    PENDING = 'pending',
    IN_PROGRESS = 'in_progress',
    DONE = 'done',
    FAILED = 'failed',
}
